// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import MiniMailIcons from './MiniMailIcons';

export type MiniMailIconsSubset = { [icon in MiniMailIcons]: string };

export let MiniMailIconsDefinitions: MiniMailIconsSubset = {
    Accounts: '\ue910',
    ContactCard: '\ueebd',
    DietPlanNotebook: '\ueac8',
    DoubleChevronDown: '\uee04',
    DoubleChevronUp: '\uedbd',
    Down: '\ue74b',
    Drm: '\ueca8',
    Error: '\ue783',
    FabricMovetoFolder: '\uf0a5',
    Fax: '\uef5c',
    Filter: '\ue71c',
    Flag: '\ue7c1',
    History: '\ue81c',
    Important: '\ue8c9',
    Label: '\ue932',
    Like: '\ue8e1',
    MailForward: '\ue89c',
    Memo: '\ue77c',
    More: '\ue712',
    NotePinned: '\ued9a',
    OpenFolderHorizontal: '\ued25',
    OutOfOffice: '\ued34',
    Phishing: '\uf679',
    Pinned: '\ue840',
    PinnedSolid: '\uf676',
    QuickNote: '\ue70b',
    Read: '\ue8c3',
    ReceiptCheck: '\uef5b',
    ReceiptForward: '\uef59',
    ReceiptReply: '\uef5a',
    RecurringTask: '\uedb2',
    Reply: '\ue97a',
    ReplyAll: '\uee0a',
    Ringer: '\uea8f',
    VoicemailForward: '\ued87',
    VoicemailReply: '\ued88',
    Zoom: '\ue71e',
};

export default {
    fontFileName: 'miniMailIcons',
    icons: MiniMailIconsDefinitions,
};
